import { type ReactNode, forwardRef } from "react";

import { Column } from "@hightouch/htui";

interface HeaderProps {
  children: ReactNode;
  mb?: number;
  stickToTop?: boolean;
}

export const Header = forwardRef<HTMLDivElement, HeaderProps>(
  ({ children, mb, stickToTop = true }, ref) => {
    return (
      <Column
        ref={ref}
        position={stickToTop ? "sticky" : "relative"}
        width="100%"
        top={0}
        left={0}
        height="max-content"
        // Keep the sticky top bar above scrolling page content (e.g. the
        // onboarding form) so content slides underneath it instead of over it.
        zIndex="docked"
        bg="white"
        mb={mb}
      >
        {children}
      </Column>
    );
  },
);

Header.displayName = "Header";
